import {restapi} from "./restapi";
import {DiscardReason} from "../models/types";


export function getDiscardReasons(): Promise<DiscardReason[]> {
    return restapi.get<DiscardReason[]>('/api/v1/smt_core/discard_reason/', {
        params: { __pagination__: 0 }
    }).then(res => res.data);
}
